import { useEffect, useState } from 'react';
import { growthApi } from '../api/phase12Client';

interface Props { onChange?: () => void }

export function ScenarioTargetsCard({ onChange }: Props) {
  const [d, setD] = useState<any>(null);
  const [edit, setEdit] = useState<Record<string, string>>({});
  const [msg, setMsg] = useState<string | null>(null);
  const load = () => growthApi.scenarioTargets().then((x) => { setD(x); setEdit(Object.fromEntries(x.scenarios.map((s: any) => [s.id, s.target_gdp_growth ?? '']))); }).catch((e) => setMsg(String(e)));
  useEffect(() => { load(); }, []);
  const save = async () => {
    setMsg(null);
    try {
      const targets: Record<string, number | null> = {};
      for (const [k, v] of Object.entries(edit)) targets[k] = v === '' ? null : parseFloat(v);
      await growthApi.setScenarioTargets(targets);
      setMsg('Targets saved — all scenario decompositions recalibrated.');
      load(); onChange?.();
    } catch (e) { setMsg(String(e)); }
  };
  const setMode = async (m: string) => { await growthApi.setScenarioTargets({}, m); load(); onChange?.(); };
  if (!d) return null;
  return (
    <div className="card" style={{ borderLeft: '4px solid #1E3A5F' }}>
      <h3>Scenario GDP targets (what each category delivers)</h3>
      <p className="small">Baseline {d.baseline_growth}% · current verified {d.current_gdp?.toFixed?.(1) ?? d.current_gdp}%. In <em>target</em> mode every lever's contribution is scaled proportionally so the scenario adds up to its target; <em>bottom-up</em> shows the raw sum of the workbook levers.</p>
      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        {['target', 'bottom_up'].map((m) => <button key={m} className={m === d.calibration_mode ? 'btn-primary' : 'btn-secondary'} onClick={() => setMode(m)}>{m === 'target' ? 'Calibrate to targets' : 'Bottom-up (raw)'}</button>)}
      </div>
      <table className="data-table">
        <thead><tr><th>Scenario</th><th>Target GDP growth (%)</th><th>Bottom-up sum</th><th>Calibration factor</th><th>BOP ceiling</th></tr></thead>
        <tbody>{d.scenarios.map((s: any) => (
          <tr key={s.id}>
            <td>{s.name}</td>
            <td><input className="field" type="number" step="0.05" style={{ width: 110 }} value={edit[s.id] ?? ''} onChange={(e) => setEdit({ ...edit, [s.id]: e.target.value })} /></td>
            <td>{s.bottom_up_gdp_growth?.toFixed(2)}%</td>
            <td>{s.calibration_factor != null ? `×${s.calibration_factor.toFixed(3)}` : '—'}</td>
            <td>{s.bop_ceiling?.toFixed(2)}%{s.target_gdp_growth != null && s.bop_ceiling != null && s.target_gdp_growth > s.bop_ceiling ? <span className="flag warn">above</span> : <span className="flag ok">ok</span>}</td>
          </tr>))}</tbody>
      </table>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
        <button className="btn-primary" onClick={save}>Save targets</button>
        {msg && <span className="small">{msg}</span>}
      </div>
    </div>
  );
}
